var _g, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6, _path7, _path8, _path9, _path0, _circle3, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalEmployees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5452_12694)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 38,
    height: 38,
    rx: 10,
    fill: "url(#paint0_linear_5452_12694)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6457,
    cy: 14.0676,
    r: 4.10662,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0859 20.7412H33.2188V19.5879C36.7838 20.6851 39.375 24.0047 39.375 27.9297V29.2109C39.375 30.0358 38.8202 30.7565 38.0166 30.9424C36.1738 31.3682 32.8334 32.0506 30.4062 32.0361C28.1358 32.0225 25.0235 31.3666 23.2686 30.9492C22.47 30.7591 21.9219 30.0406 21.9219 29.2197V27.9297C21.9219 24.0019 24.5169 20.6807 28.0859 19.5859V20.7412Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5938 28.0408L29.6888 22.7891H31.6053L32.7004 28.3172L30.7839 29.9756L28.5938 28.0408Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5938 21.2578L29.4737 23.3111H31.8204L32.7004 21.2578H28.5938Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0805 23.3031L26.5781 20.7942L29.1071 19.4531L30.6471 21.2498L28.0805 23.3031Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2151 23.3031L34.625 20.7383L32.1884 19.4531L30.6485 21.2498L33.2151 23.3031Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.655,
    cy: 18.1629,
    r: 3.17067,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6807 23.3145H41.6445V22.4238C44.3967 23.271 46.3973 25.8342 46.3975 28.8643V29.8535C46.3975 30.4905 45.9683 31.047 45.3477 31.1904C43.9248 31.5192 41.3465 32.0463 39.4727 32.0352C37.7197 32.0247 35.3169 31.5185 33.9619 31.1963C33.3452 31.0496 32.9219 30.4943 32.9219 29.8604V28.8643C32.9221 25.8319 34.9253 23.2672 37.6807 22.4219V23.3145Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0703 28.9532L38.9158 24.8984H40.3955L41.241 29.1666L39.7613 30.4471L38.0703 28.9532Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeWidth: 0.772088,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0703 23.7109L38.7497 25.2963H40.5616L41.241 23.7109H38.0703Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeWidth: 0.772088,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6756 25.2928L36.5156 23.3557L38.4683 22.3203L39.6573 23.7075L37.6756 25.2928Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeWidth: 0.772088,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.638 25.2928L42.7266 23.3126L40.8453 22.3203L39.6563 23.7075L41.638 25.2928Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeWidth: 0.772088,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.241,
    cy: 18.1629,
    r: 3.17067,
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2666 23.3145H23.2305V22.4238C25.9827 23.271 27.9832 25.8342 27.9834 28.8643V29.8535C27.9834 30.4905 27.5542 31.047 26.9336 31.1904C25.5107 31.5192 22.9324 32.0463 21.0586 32.0352C19.3056 32.0247 16.9028 31.5185 15.5479 31.1963C14.9311 31.0496 14.5078 30.4943 14.5078 29.8604V28.8643C14.508 25.8319 16.5112 23.2672 19.2666 22.4219V23.3145Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 28.9532L20.5018 24.8984H21.9814L22.8269 29.1666L21.3473 30.4471L19.6562 28.9532Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeWidth: 0.772088,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 23.7109L20.3357 25.2963H22.1475L22.8269 23.7109H19.6562Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeWidth: 0.772088,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2615 25.2928L18.1016 23.3557L20.0542 22.3203L21.2432 23.7075L19.2615 25.2928Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeWidth: 0.772088,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2239 25.2928L24.3125 23.3126L22.4313 22.3203L21.2423 23.7075L23.2239 25.2928Z",
    fill: "white",
    stroke: "#0A85F8",
    strokeWidth: 0.772088,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5452_12694",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5452_12694"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5452_12694"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5452_12694"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5452_12694",
    result: "effect2_dropShadow_5452_12694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5452_12694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5452_12694",
    x1: 12,
    y1: 2,
    x2: 50,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEmployees);
export default __webpack_public_path__ + "static/media/Total Employees.4852a17ea3221ed6bdf75d6bc000d357.svg";
export { ForwardRef as ReactComponent };